// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3gtrE","name":"styles_name__1F40X","phone":"styles_phone__3l2Pe"};